// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AppWrapper from './App'; // Import the new AppWrapper

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);